<!--
Use ngx-loading-bar/http-client when load this page.
-->
<ngx-loading-bar [color]="'white'"></ngx-loading-bar>
<!-- / -->

<ng-container *ngIf="voucher?.id">
  <div id="content">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <ol class="breadscrumbs">
            <li><a [routerLink]="['/']">Início</a></li>
            <li><p>Cupom de Desconto</p></li>
          </ol>
        </div>

        <div class="col-12">
          <div class="voucher">
            <div class="voucher-container">
              <h3 class="py-4">CUPOM DE DESCONTO</h3>
            </div>
            <div class="p-5">
              <a [routerLink]="['/']">
                <img class="mx-auto d-block" width="245" height="85" src="/assets/themes/{{environment.marketplace.domainObject.sld}}/images/logo.png" alt="CUPOM" />
              </a>
            </div>
            <div class="voucher-container" style="background-color: white">
              <ng-container *ngIf="voucher.price_discount_type == 'fixed'">
                <h2>R$ {{voucher.price_discount | number:'1.2-2':'pt-BR'}} DE DESCONTO EM SUA COMPRA</h2>
              </ng-container>
              <ng-container *ngIf="voucher.price_discount_type == 'percent'">
                <h2>{{voucher.price_discount | number:'1.2-2':'pt-BR'}}% DE DESCONTO EM SUA COMPRA</h2>
              </ng-container>
              <p>Utilize <strong>{{voucher.name | uppercase}}</strong> em sua próxima compra e tenha acesso a esse suporte desconto! Promoção válida por tempo limitado ou enquanto durarem os estoques. Sempre consulte regulamento atualizado para uso do seu CUPOM.</p>
            </div>
            <div class="voucher-container">
              <p class="mt-2">CUPOM de Desconto: <span class="voucher-promo">{{voucher.name | uppercase}}</span></p>
              <ng-container *ngIf="voucher.valid_until_at != null">
                <p class="voucher-expire">Expira em: {{voucher.valid_until_at}}</p>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!--
<ng-container *ngIf="!voucher?.id">
  <div id="content">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <ol class="breadscrumbs">
            <li><a [routerLink]="['/']">Início</a></li>
            <li><a >Cupom de Desconto</a></li>
          </ol>
        </div>

        <div class="col-12">
          <div class="voucher">
            <div class="voucher-container">
              <h3>CUPOM DE DESCONTO</h3>
            </div>
            <div class="voucher-container" style="background-color:white">
              Esse CUPOM de DESCONTO não existe ou não está mais ativo em nossa loja.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
-->
